import script from "./PaymentStatusBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentStatusBar.vue?vue&type=script&setup=true&lang=js"

import "./PaymentStatusBar.vue?vue&type=style&index=0&id=3895e5c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3895e5c3"]])

export default __exports__